import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CategoryWiseSubCategoryModal from '@features/measurement/components/CategoryWiseSubCategoryModal';

import { fetchAllCategoryWiseSubCategoryCount } from '@services/measurementService';

const MeasurementTemplate = () => {
	const [templateList, setTemplateList] = useState([]);
	const [filteredTemplateList, setFilteredTemplateList] = useState([]);
	const [selectedId, setSelectedId] = useState(null);
	const [searchValue, setSearchValue] = useState('');
	const navigate = useNavigate();

	const onFetchData = async () => {
		const data = await fetchAllCategoryWiseSubCategoryCount();
		setFilteredTemplateList(data);
		setTemplateList(data);
	};

	useEffect(() => {
		onFetchData();
	}, []);

	const onSearchTemplates = (e) => {
		setSearchValue(e.target.value);
		let searchResult = e.target.value
			? templateList.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
			: templateList;
		setFilteredTemplateList(searchResult);
	};

	return (
		<>
			<div className="top-header bg-white">
				<div className="page-title-area pb-2 d-flex align-items-center">
					<button className="button text size32 p-0" onClick={() => navigate('/configuration')}>
						<img src={`${process.env.PUBLIC_URL}/icons/left-arrwo-dark.svg`} alt="back" />
					</button>
					<h1 className="semibold-16">CONFIGURATION</h1>
				</div>

				<div className="filter-container-top bg-gray">
					<div className="sample-full-status">
						<ul className="common-list-component">
							<li>{filteredTemplateList?.length} Items</li>
						</ul>
					</div>
					<div className="filter-actions sample-dashboard-filter">
						<div className="form-group size32 m-0 search-filter filter-with-animation">
							<div className="with-icon right-icon">
								<input
									type="text"
									placeholder="Search"
									name="name"
									onChange={onSearchTemplates}
									value={searchValue}
									autoComplete="off"
								/>
								<span className="right-icon">
									<img
										src={`${process.env.PUBLIC_URL}/icons/search-dark.svg`}
										alt="search"
									/>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="body-content pt-2">
				<section className="measurement-section">
					<div className="measurement-items">
						{filteredTemplateList?.map((item) => (
							<div
								className="cursor-pointer measuremen-single d-flex justify-content-between align-items-center align-self-center"
								onClick={() => setSelectedId(item)}
								key={item?.id}
							>
								<div className=" d-flex justify-content-start">
									<div className="dress-img">
										<img
											src={
												item?.docUrl ||
												process.env.PUBLIC_URL + '/icons/pom/t-shirt.png'
											}
											alt="tee"
										/>
									</div>
									<div className="title-subtitle d-flex justify-content-center flex-column align-self-center">
										<p className="p-0 m-0 regular-14 weight-500 gray_dark_01">
											{item?.name}
										</p>
										<p className="subtitle regular-12 weight-400 gray_dark_02">
											Sub-category
											<span className="gray_dark_01 weight-500">
												{item?.subCategoryCount}
											</span>
										</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</section>
			</div>

			{selectedId && (
				<CategoryWiseSubCategoryModal
					selectedItem={selectedId}
					onClose={() => setSelectedId(null)}
					onFetchData={onFetchData}
				/>
			)}
		</>
	);
};

export default MeasurementTemplate;
